import styled from "styled-components";
import { MainWrapper } from "../../containers/Protected/Protected.styled";

export const TradingHistoryWrapper = styled(MainWrapper)``;
